module.exports = __webpack_public_path__ + "static/img/lb4.c0c47ddb.png";